
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsConnectEdcBankDialog extends Serenity.EntityDialog<PsConnectEdcBankRow, any> {
        protected getFormKey() { return PsConnectEdcBankForm.formKey; }
        protected getIdProperty() { return PsConnectEdcBankRow.idProperty; }
        protected getLocalTextPrefix() { return PsConnectEdcBankRow.localTextPrefix; }
        protected getNameProperty() { return PsConnectEdcBankRow.nameProperty; }
        protected getService() { return PsConnectEdcBankService.baseUrl; }
        protected getDeletePermission() { return PsConnectEdcBankRow.deletePermission; }
        protected getInsertPermission() { return PsConnectEdcBankRow.insertPermission; }
        protected getUpdatePermission() { return PsConnectEdcBankRow.updatePermission; }

        protected form = new PsConnectEdcBankForm(this.idPrefix);

    }
}